import { ReactElement, useCallback, useEffect, useMemo, useState } from 'react';
import '@assets/styles/pages/factory-list-page.scss';
import { SiteSummaryCard } from '../contractorNavigation/siteSummaryCard';
import { useLocation } from 'react-router-dom';
import { Wrapper } from '@components/common/Wrapper/wrapper';
import { Modal } from '@components/common/modal/modal';
import { useContractor360Store } from '@store/contractor360Store';
import { NavigatorTab, SiteStatusModal } from '@components/common';
import { useFormik } from 'formik';
import { SiteSummaryTabContractor } from '@components/siteSummary';
import { SsSiteSummaryFilterTag } from './components/siteSummerSSFilterTag';
import { useSiteSummarySSQuery } from '@services/hooks/contractor360/useSiteSummarySS';
import { SsSiteSummaryFilters } from './components/siteSummerSSFilters';
import { overlayAddFadeAction, overlayRemoveFadeAction } from '@components/common/sort';
import { SSSummerySearch } from './components/siteSummerSSSearch';
import { useSsSiteSummaryListingStore } from '@store/ssSiteSummaryFilterStore';
import { useFilterStore } from '@store/filter';
import { SiteSummaryDetails } from '@services/hooks/contractor360';
import { sortByDateFieldDesc } from '@helper/utils';

export const SiteSummarySSList = (): ReactElement => {
	const { state } = useLocation();
	const { isSiteStatusModalOpen, setSiteStatusModal } = useContractor360Store();
	const [openFilter, setOpenFilter] = useState<boolean>(false);
	const [siteList, setSiteList] = useState<SiteSummaryDetails[]>([]);
	const [totalCount, setTotalCount] = useState<number>(0);
	const { search } = useFilterStore();

	const {
		data: siteSummmaryData,
		isFetching: isSiteSummaryFetching,
		error: siteSummaryError,
	} = useSiteSummarySSQuery(state.sfid);
	const { allSSSiteSummaryFilter } = useSsSiteSummaryListingStore();

	const formik = useFormik({
		initialValues: {
			siteStatus: '',
		},
		onSubmit: () => {},
	});

	const siteSearchHandlerOpen = useCallback(() => {
		overlayAddFadeAction(() => setOpenFilter(true));
	}, []);

	const siteSearchHandlerClose = useCallback(() => {
		overlayRemoveFadeAction(() => setOpenFilter(false));
	}, []);

	const sortedData = useMemo(() => {
		return sortByDateFieldDesc<SiteSummaryDetails>(siteSummmaryData ?? [], 'createddate');
	}, [siteSummmaryData]);

	useEffect(() => {
		let filtered = sortedData;

		if (allSSSiteSummaryFilter?.ss_code) {
			filtered = filtered.filter((e) => e.site_specialist_code === allSSSiteSummaryFilter.ss_code);
		}

		if (search.trim() !== '') {
			filtered = filtered.filter((e) => e.name?.toLowerCase().includes(search.toLowerCase()));
		}

		setSiteList(filtered);
		setTotalCount(filtered.length);
	}, [sortedData, allSSSiteSummaryFilter, search]);

	return (
		<>
			<section className="tab-search-section" id="site-summary">
				<div className="container">
					<NavigatorTab
						state={state}
						tabList={SiteSummaryTabContractor}
						selectedFilterChild={<SsSiteSummaryFilterTag count={totalCount} />}
					></NavigatorTab>
					<SSSummerySearch setSiteSummaryFilterCallback={siteSearchHandlerOpen} />
				</div>
			</section>
			{openFilter && <SsSiteSummaryFilters openFilters={openFilter} closeFilters={siteSearchHandlerClose} />}
			<section className="site-summary-wrapper">
				<Wrapper isLoaderVisible={isSiteSummaryFetching} isError={siteSummaryError}>
					<div className="container">
						<ul className="site-summary-card row">
							{siteList?.length ? (
								siteList?.map((site) => {
									return <SiteSummaryCard key={site.id} site={site} />;
								})
							) : (
								<li className="d-col d-col-2">
									<div className="summary-info-main">
										<p className="h3">No Data Found!</p>
									</div>
								</li>
							)}
						</ul>
					</div>
				</Wrapper>
				<Modal
					modalId="siteStatus"
					className="dialog dialog-sm site-summary-status-popup close-site-popup pt-4"
					modalOpen={isSiteStatusModalOpen}
					onModalClose={() => setSiteStatusModal(false)}
				>
					<SiteStatusModal formik={formik} />
				</Modal>
			</section>
		</>
	);
};
